import { render, staticRenderFns } from "./AssessmentFormKPI.vue?vue&type=template&id=44010b57&scoped=true&"
import script from "./AssessmentFormKPI.vue?vue&type=script&lang=js&"
export * from "./AssessmentFormKPI.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentFormKPI.vue?vue&type=style&index=0&id=44010b57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44010b57",
  null
  
)

export default component.exports